type DateType = 'time' | 'full'

const dateFormat = (date: string, type?: DateType) => {
  const dateObject = new Date(date)
  const day = dateObject.getDate()
  const month = dateObject.getMonth() + 1
  const year = dateObject.getFullYear()
  const hours = dateObject.getHours()
  const minutes = dateObject.getMinutes()

  if (type === 'time') {
    return `${hours}:${minutes}`
  }
  if (type === 'full') {
    return `${day}/${month}/${year} ${hours}:${minutes}`
  }
  return `${day}/${month}/${year}`
}

export default dateFormat
